import { render } from "./FilterButtonAddChip.vue?vue&type=template&id=2096d616&scoped=true"
import script from "./FilterButtonAddChip.vue?vue&type=script&lang=js"
export * from "./FilterButtonAddChip.vue?vue&type=script&lang=js"

import "./FilterButtonAddChip.vue?vue&type=style&index=0&id=2096d616&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2096d616"]])

export default __exports__